import React from 'react';
import { DealerOverview } from 'site-modules/shared/components/inventory/contact-dealer/dealer-overview/dealer-overview';

export function NonPartnerOverview() {
  return (
    <DealerOverview className="border-top mt-1_5 pt-1_5 d-flex flex-column gap-0_5">
      <DealerOverview.FiveStar />
      <DealerOverview.Location />
      <DealerOverview.Delivery />
      <DealerOverview.Phone />
    </DealerOverview>
  );
}
